<template>
<div>
  <div class="sub-header-container">
    <div class="sub-header-content" style="justify-content: center;">
      <div class="page-title-container" style="padding-top:40px; padding-bottom: 40px;">
        <div class="page-title">Reset your password</div>
      </div>
    </div>
  </div>

  <div class="page-container">
    <div style="display: flex; justify-content: center;">
      <div v-if="showFormEmail" class="register-container">
        
        <p>We will send you an email to recover your password. Check your email inbox.</p>

        <div style="margin-bottom: 20px; margin-top: 30px;">
          <p style="margin-bottom: 0px;">Email adress</p>          
          <input class="input-add" style="width: 90%;" placeholder="Enter your email" ref="email" v-model="email" @click="selectEmail" type="text" @keyup.enter="recover">
        </div>

        <button class="primary-button" style="width: 100%; margin-left: 0px;" @click="recover">Reset password</button>
      </div>
    </div>

    <div v-if="showSuccess">
      <div style="display: flex; justify-content: center;">
        <div class="register-container" style="text-align: center;">
          <div class="p-ok" >
            <p>If the email adress was registered on ThreadOk <b>you will receive an email with a link to reset your password.</b></p>
            <p>Check your inbox and your spam box.</p>
          </div>
          <button class="primary-button" @click="$router.push({ path: '/login' })">Return to Log in</button>
        </div>
      </div>  
    </div>
  </div>
  
  <p class="p-error" v-if="showEmailBadFormat">Email format required, example: john@domain.com</p>
  
</div>
</template>

<script>
import * as validator from 'email-validator'
import firebase from '@/firebase'
import utils from '@/utils'

export default {
  name: 'PasswordReset',

  data (){
    return {
      email: '',
      showFormEmail: true,
      showSuccess: false,
      showEmailBadFormat: false,
    }
  },

  mounted() {
    this.focusEmail()
  },

  methods: {
    focusEmail() {
      this.$refs.email.focus()
    },

    selectEmail(event) {
      event.target.setSelectionRange(0, this.email.length)
    },

    recover() {
      this.showEmailBadFormat = false
      if(!validator.validate(this.email)){
        this.showEmailBadFormat = true
        this.focusEmail()
        return
      }

      firebase.auth
        .sendPasswordResetEmail(this.email)
          .then(() => {
            this.showFormEmail = false
            this.showSuccess = true
          })
          .catch((error) => {
            if(utils.isDev) {
              console.error(error)
            }

            this.showFormEmail = false
            this.showSuccess = true
          })
    },
  }
}
</script>

<style scoped>
.p-error {
  color: red;
}
.p-ok {
  display: block;
  text-align: center;
  color: var(--secondary-text-color);
}

.header-container{
  background-color: transparent;
  max-width: 1100px;
  padding: 10px 3rem 10px 3rem;
  margin: 0 auto;
}
.sub-header-container{
  background-color: transparent;
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0 auto 10px auto;
}
.page-container{
  max-width: 1100px;
  padding: 0 2rem;
  margin: 0 auto;
}
@media (max-width: 760px){
  .header-container{
  padding: 0 0.5rem;
  }
  .sub-header-container{
  padding: 0 0.5rem;
  }
  .page-container{
  padding: 0 0.5rem;
  }
  .website-name{
    font-size: 15px;
  }
   .website-name-container img{
    width: 22px;
  }
  .website-name-container p{
    display: none;
  }
}

</style>
